import { useAuth0 } from "@auth0/auth0-react";
import { CircularProgress } from "@mui/material";
import { LoginContainer } from "components/LoginContainer";
import { abortAll } from "context/graphql/client";
import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "store";
import { setForcedOffline } from "store/root.store";
import { logout, setLoggedOut } from "store/slices/user.store";

export const LogoutPage: FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { logout: auth0logout } = useAuth0();

  useEffect(() => {
    async function logOutUser() {
      await dispatch(setLoggedOut());
      await dispatch(logout());
      await auth0logout({ localOnly: true });
      navigate(`/login`, { replace: true });
    }
    abortAll("LOGOUT");
    dispatch(setForcedOffline({ status: false }));
    logOutUser();
  }, [auth0logout, dispatch, navigate]);

  return (
    <LoginContainer>
      <CircularProgress size={24} />
    </LoginContainer>
  );
};
